import React, {useState, useEffect, useRef, memo} from 'react'
import {flushSync} from 'react-dom'
import {Redirect} from 'react-router-dom'
import {ServerConfig} from 'config'
import axios from 'axios'
import {useSelector} from 'react-redux'

import Select from 'react-select';
import DatePicker from "react-datepicker";

import {PDFExport} from "@progress/kendo-react-pdf";
import PageTemplate from "./pageTemplate";
import {InfoOutlined} from '@material-ui/icons'

import "react-datepicker/dist/react-datepicker.css";

import {makeStyles} from '@material-ui/core/styles'
import {Typography, Grid, Button} from '@material-ui/core'

import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';





import _, {get} from 'lodash'

import logo_mono from 'assets/img/logo/logo_circle_mono.png'

const useStyles = makeStyles((theme) => ({
  	datePickerPopper: {
        zIndex: '999 !important',
    },
}))

function utc_timestamp_to_local_datetime_string(ts) {
  let date_string = new Date(ts).toLocaleDateString("en-US");
  let time_string = new Date(ts).toLocaleTimeString("en-US", {timeZoneName: "short"})

  return date_string + " " + time_string;
}

// mirrors DR6_MATERIAL_TO_DORIIS_CODE in doriis.py
const DR6_MATERIAL_TO_DORIIS_CODE = {
  'aluminum': 'AL1',
  'glass': 'GLM',
  'bi-metal': 'BM1',
  'pete': 'PL1',
  'hdpe': 'PL2',
  'pvc': 'PL3',
  'ldpe': 'PL4',
  'pp': 'PL5',
  'ps': 'PL6',
  'other': 'PL7',
  'bag-in-box': 'WDSBIB',
  'multilayer-pouch': 'WDSMLP',
  'paperboard-carton': 'WDSPC',
}

// builds the DORIIS shipping report file client-side, mirrors
// generate_dr6_doriis_line in doriis.py (21 comma-separated fields).
// FSN is the saved DR6 id, so entries need to be saved first.
function generateDoriisContent(dr6DataArray, receiverAccountNumber) {
  const lines = dr6DataArray.map(d => {
    const code = DR6_MATERIAL_TO_DORIIS_CODE[d.material?.toLowerCase()]
    if (!code) return null
    const fromDate = new Date(d.begin_ts).toLocaleDateString('en-US', {timeZone: 'America/Los_Angeles', month: '2-digit', day: '2-digit', year: 'numeric'})
    const thruDate = new Date(d.end_ts).toLocaleDateString('en-US', {timeZone: 'America/Los_Angeles', month: '2-digit', day: '2-digit', year: 'numeric'})
    const weight = parseFloat(d.crv_weight_lbs || 0).toFixed(1)
    return [
      d.cert_numbers, receiverAccountNumber, code, fromDate, thruDate,
      '', '', '', '', '', '',
      weight, '', 'Y',
      '', '', '', '', '', d.fsn ?? '', '',
    ].join(',')
  }).filter(Boolean)
  return lines.join('\n') + '\n'
}



const DR6 = () => {
  // useRef, not createRef - the save buttons call .save() after an async
  // save + re-render, and createRef would hand them a stale (null) ref
  const ref = useRef(null);
  const refAllPdf = useRef(null);  // combined PDF of every "All" material
  const savingRef = useRef(null);  // in-flight dr6_save promise, blocks double saves
  const token = useSelector(state => state.auth.access_token)

  const tenant = useSelector(state => state.auth.tenant)
  console.log(tenant);
  console.log(tenant.state);

  const [availableCertIDs, setAvailableCertIDs] = useState([])
  const [selectedCertID, setSelectedCertID] = useState({label: 'Please Select', value: ''})
  const [selectedCertID_prev, setSelectedCertID_prev] = useState({label: 'Please Select', value: ''})
  const [dailySummaries, setDailySummaries] = useState([])
  const [DR6Data, setDR6Data] = useState({})
  const [DR6List, setDR6List] = useState([])
  const [allowSave, setAllowSave] = useState(false)
  const [DR6DataAll, setDR6DataAll] = useState([])  // "All" materials results
  const [allowSaveAll, setAllowSaveAll] = useState(false)
  const [allSaving, setAllSaving] = useState(false)
  const [allDoriisPromptOpen, setAllDoriisPromptOpen] = useState(false)
  const [allDoriisReceiver, setAllDoriisReceiver] = useState(null)
  const [allGenerateMessage, setAllGenerateMessage] = useState('')
  const [allIndex, setAllIndex] = useState(0)  // which "All" material is shown in the PDF preview
  const [savedMaterials, setSavedMaterials] = useState({})  // { material: true } once saved

  const weight_decimals = 1

  // DORIIS export state - which row (dr6.id) currently has its
  // missing-fields prompt open, and the values being entered for it
  const [doriisPromptId, setDoriisPromptId] = useState(null)
  const [doriisDownloadingId, setDoriisDownloadingId] = useState(null)
  const [promptShippingDate, setPromptShippingDate] = useState(null)
  const [promptReceiverOption, setPromptReceiverOption] = useState(null)
  const [receiverSearchOptions, setReceiverSearchOptions] = useState([])
  const [receiverSearchLoading, setReceiverSearchLoading] = useState(false)

  // opt-in shipment bundling - hidden by default, only appears once a
  // customer clicks the toggle link. Existing customers who never touch it
  // see no difference at all.
  const [shipmentSelectEnabled, setShipmentSelectEnabled] = useState(false)
  const [selectedForShipment, setSelectedForShipment] = useState({}) // { id: dr6line }
  const [shipmentDownloading, setShipmentDownloading] = useState(false)
  const [shipmentPromptOpen, setShipmentPromptOpen] = useState(false)

  let date_before_one_week = new Date();
  date_before_one_week.setDate(date_before_one_week.getDate() - 7);

  const [startDate, setStartDate] = useState(date_before_one_week);
  const [startDateStatus, setStartDateStatus] = useState("");
  const [startDate_prev, setStartDate_prev] = useState(date_before_one_week);

  const [endDate, setEndDate] = useState(new Date());
  const [endDate_prev, setEndDate_prev] = useState(new Date());

  let materials_and_abbreviations = [
    ['alu', 'Aluminum', 'Alu'],
    ['bi-metal', 'Bi-Metal', 'Bi-M'],
    ['pete', 'PETE', 'PETE'],
    ['hdpe', 'HDPE', 'HDPE'],
    ['ldpe', 'LDPE', 'LDPE'],
    ['pp', 'PP', 'PP'],
    ['ps', 'PS', 'PS'],
    ['pvc', 'PVC', 'PVC'],
    ['other', 'OTHER', 'OTHER'],
    ['glass', 'Glass', 'Glass'],
    ['bib', 'Bag-in-Box', 'BiB'],
    ['pc', 'Paperboard-Carton', 'PC'],
    ['mp', 'Multilayer-Pouch', 'MP'],
  ]
  let options = [];
  let materialAbbrevByValue = {};
  for (let idx in materials_and_abbreviations) {
    const [key, label, abbrev] = materials_and_abbreviations[idx];
    options.push({value: label, label: abbrev});
    materialAbbrevByValue[label.toLowerCase()] = abbrev;
  }
  // "All" is appended at the END so Aluminum stays the first/default option
  const materialsFilterOptions = [...options, {value: 'All', label: 'All'}]
  const [availableMaterials, setAvailableMaterials] = useState(materialsFilterOptions)
  const [selectedMaterials, setSelectedMaterials] = useState(options[0]);
  const [selectedMaterials_prev, setSelectedMaterials_prev] = useState(options[0]);
  const [actuallyShippedLbsCrv, setActuallyShippedLbsCrv] = useState();
  const [actuallyShippedLbsScrap, setActuallyShippedLbsScrap] = useState();

  const [value, setValue] = React.useState('1');  // for tabs

  let default_options;
  if (tenant.state == "CA") {
    default_options = ["sizes", "weights"];
  } else if (tenant.state == "NY") {
    default_options = [];
  } else {
    default_options = ["sizes", "weights"];
  }

  const [cols, setCols] = useState([]);
  const [heads, setHeads] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles()

  async function fetchCertIDList(token){
      const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/cert_ids`, config);
    const options = [];

    for (let idx in results.data) {
      options.push({value: results.data[idx], label: results.data[idx]});
    }

    setAvailableCertIDs(options);
    if (options.length > 0) {
      setSelectedCertID_prev(options[0]);
      setSelectedCertID(options[0]);
    }
  }

  function updateStartDateForMaterial() {
    if (selectedMaterials.value === 'All') return

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    axios.post(
      `${ServerConfig.SERVER_URL}/tenant/dr6_new_startdate`,
      {
        cert_id: selectedCertID.value,
        material: selectedMaterials.value,
      }, config).then(function (response) {
      setStartDate(new Date(response.data.enddatetime));
      setStartDateStatus(" Automatically populated")
    }).catch((error) => {
      setStartDate(date_before_one_week)
      setStartDateStatus(" No previous reports")
    })

  }

  function mark_saved() {
    setIsLoading(true);

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = axios.post(
      `${ServerConfig.SERVER_URL}/tenant/dr6_save`,
      {
        cert_id: selectedCertID.value,
        ts_from_utc: startDate.getTime(),
        ts_to_utc: endDate.getTime(),
        material: selectedMaterials.value === 'All' ? DR6Data.material : selectedMaterials.value,
        actually_shipped_lbs_crv: selectedMaterials.value === 'All' ? undefined : actuallyShippedLbsCrv,
        actually_shipped_lbs_scrap: selectedMaterials.value === 'All' ? undefined : actuallyShippedLbsScrap,
        shipping_date: promptShippingDate ? promptShippingDate.getTime() : null,
      }, config).then(function (response) {
      // the saved id is the report's FSN - flushSync so the PDF rendered
      // right after this already shows it
      const fsn = response.data.id
      flushSync(() => {
        setDR6Data(prev => ({...prev, fsn}))
        setDR6DataAll(prev => prev.map(d => d.material === DR6Data.material ? {...d, fsn} : d))
      })
      if (selectedMaterials.value === 'All') {
        setSavedMaterials(prev => ({...prev, [DR6Data.material]: true}))
      }
      // saved once - button flips to plain "Download PDF" so it can't save again
      setAllowSave(false)
      fetchDR6List(token);
      updateStartDateForMaterial();
    }).finally(() => {
      savingRef.current = null
    })
    savingRef.current = results

    setIsLoading(false);
    return results
  }

  function fetchDR6List(token) {
    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const isAll = selectedMaterials_prev.value === 'All'

    const results = axios.post(
      `${ServerConfig.SERVER_URL}/tenant/dr6_list`,
      {
        cert_id: selectedCertID_prev.value,
        ts_from_utc: startDate_prev.getTime(),
        ts_to_utc: endDate_prev.getTime(),
        ...(isAll ? {} : {material: selectedMaterials_prev.value}),
      }, config).then(function (results) {
      setDR6List(results.data);
    });
  }

  function fetchDR6byId(dr6_id) {
    console.log("Fetching DR6-data with id" + dr6_id)

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = axios.post(
      `${ServerConfig.SERVER_URL}/tenant/dr6_load`,
      {
        id: dr6_id,
      }, config).then(function (response) {
      setAllowSave(false);
      setDR6Data(response.data);
    })
  }

  // ── DORIIS export ──────────────────────────────────────────────────────

  function authConfig() {
    const config = {headers: {'Content-Type': 'application/json'}}
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  }

  // searches ShippingFacility for PROCESSOR (receiver) matches - reuses the
  // same /tenant/shipping_facilities endpoint the DORIIS search work built
  async function searchReceivers(query) {
    setReceiverSearchLoading(true)
    try {
      const path = query
        ? `shipping_facilities/PROCESSOR/${encodeURIComponent(query)}/1`
        : `shipping_facilities/PROCESSOR/1`
      const res = await axios.get(`${ServerConfig.SERVER_URL}/tenant/${path}`, authConfig())
      const opts = (res.data.items || []).map((f) => ({
        value: f.account_number,
        label: `${f.organization_name || f.program_name || 'Unknown'} (${f.account_number})`,
      }))
      setReceiverSearchOptions(opts)
    } catch (err) {
      console.error('Failed to search receivers', err)
      setReceiverSearchOptions([])
    }
    setReceiverSearchLoading(false)
  }

  // opens the inline prompt for a row, pre-filling whatever it already has
  function openDoriisPrompt(dr6line) {
    setDoriisPromptId(dr6line.id)
    setPromptShippingDate(
      dr6line.shipping_date ? new Date(dr6line.shipping_date) : null
    )
    setPromptReceiverOption(
      dr6line.receiver_account_number
        ? {value: dr6line.receiver_account_number, label: dr6line.receiver_account_number}
        : null
    )
    setReceiverSearchOptions([])
    searchReceivers('')
  }

  function closeDoriisPrompt() {
    setDoriisPromptId(null)
  }

  // does the actual export call and triggers the browser download
  async function downloadDoriisReport(dr6_id, extraPayload = {}) {
    setDoriisDownloadingId(dr6_id)

    try {
      const res = await axios.post(
        `${ServerConfig.SERVER_URL}/tenant/dr6_doriis_export`,
        {id: dr6_id, ...extraPayload},
        {...authConfig(), responseType: 'blob'}
      )

      let filename = `DORIIS_DR6_${dr6_id}.txt`
      const disposition = res.headers['content-disposition']
      if (disposition) {
        const match = disposition.split(/;(.+)/)[1]?.split(/=(.+)/)[1]
        if (match) filename = match.replace(/['"]/g, '')
      }

      const blob = new Blob([res.data], {type: 'text/plain'})
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)

      closeDoriisPrompt()
      fetchDR6List(token)  // refresh so the row now shows its saved receiver/shipping_date
    } catch (err) {
      console.error('Failed to download DORIIS report', err)
      alert(
        err.response?.data?.message ||
        'Error downloading DORIIS report. Missing receiver or shipping date?'
      )
    }

    setDoriisDownloadingId(null)
  }

  // click handler for the "DORIIS Report" cell - only prompts if something's
  // actually missing, otherwise downloads straight away
  function handleDoriisClick(dr6line) {
    if (doriisDownloadingId === dr6line.id) return

    if (dr6line.receiver_account_number && dr6line.shipping_date) {
      downloadDoriisReport(dr6line.id)
    } else {
      openDoriisPrompt(dr6line)
    }
  }

  function confirmDoriisDownload(dr6line) {
    const payload = {}

    if (!dr6line.shipping_date && promptShippingDate) {
      payload.shipping_date = promptShippingDate.getTime()
    }
    if (!dr6line.receiver_account_number && promptReceiverOption) {
      payload.receiver_account_number = promptReceiverOption.value
    }

    if (!dr6line.receiver_account_number && !payload.receiver_account_number) {
      alert('Please select a receiver before downloading.')
      return
    }

    downloadDoriisReport(dr6line.id, payload)
  }

  // ── shipment bundling (multiple materials into one DORIIS file) ────────

  function toggleShipmentSelect() {
    if (shipmentSelectEnabled) {
      setSelectedForShipment({})
      setShipmentPromptOpen(false)
    }
    setShipmentSelectEnabled(!shipmentSelectEnabled)
  }

  function toggleShipmentRow(dr6line, checked) {
    setSelectedForShipment(prev => {
      const next = {...prev}
      if (checked) {
        next[dr6line.id] = dr6line
      } else {
        delete next[dr6line.id]
      }
      return next
    })
  }

  function clearShipmentSelection() {
    setSelectedForShipment({})
    setShipmentPromptOpen(false)
  }

  async function downloadShipmentCombined(extraPayload = {}) {
    const ids = Object.keys(selectedForShipment).map(Number)
    setShipmentDownloading(true)

    try {
      const res = await axios.post(
        `${ServerConfig.SERVER_URL}/tenant/dr6_doriis_export`,
        {ids, ...extraPayload},
        {...authConfig(), responseType: 'blob'}
      )

      let filename = `DORIIS_DR6_shipment.txt`
      const disposition = res.headers['content-disposition']
      if (disposition) {
        const match = disposition.split(/;(.+)/)[1]?.split(/=(.+)/)[1]
        if (match) filename = match.replace(/['"]/g, '')
      }

      const blob = new Blob([res.data], {type: 'text/plain'})
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)

      setShipmentPromptOpen(false)
      clearShipmentSelection()
      fetchDR6List(token)
    } catch (err) {
      console.error('Failed to download combined DORIIS report', err)
      alert(err.response?.data?.message || 'Error downloading combined DORIIS report.')
    }

    setShipmentDownloading(false)
  }

  // one shared prompt for the whole selection, not per-report - matches
  // the write-once backend behavior (only fills in reports missing it)
  function attemptShipmentDownload() {
    const entries = Object.values(selectedForShipment)
    const missingShippingDate = entries.some(e => !e.shipping_date)
    const missingReceiver = entries.some(e => !e.receiver_account_number)

    if (!missingShippingDate && !missingReceiver) {
      downloadShipmentCombined()
      return
    }

    setPromptShippingDate(new Date())
    setPromptReceiverOption(null)
    setReceiverSearchOptions([])
    searchReceivers('')
    setShipmentPromptOpen(true)
  }

  function confirmShipmentDownload() {
    const entries = Object.values(selectedForShipment)
    const missingShippingDate = entries.some(e => !e.shipping_date)
    const missingReceiver = entries.some(e => !e.receiver_account_number)

    if (missingReceiver && !promptReceiverOption) {
      alert('Please select a receiver before downloading.')
      return
    }

    const payload = {}
    if (missingShippingDate && promptShippingDate) {
      payload.shipping_date = promptShippingDate.getTime()
    }
    if (missingReceiver && promptReceiverOption) {
      payload.receiver_account_number = promptReceiverOption.value
    }

    downloadShipmentCombined(payload)
  }

  // shows material at idx in the existing PDF preview
  function goToAllPage(idx) {
    const d = DR6DataAll[idx]
    if (!d) return
    setAllIndex(idx)
    setDR6Data(d)
    setAllowSave(!savedMaterials[d.material])
  }

  // saves every generated material not saved yet; extraPayload lets the DORIIS flow add the receiver
  async function saveAllMaterials(extraPayload = {}) {
    const unsaved = DR6DataAll.filter(d => !savedMaterials[d.material])
    const responses = await Promise.all(unsaved.map(d =>
      axios.post(
        `${ServerConfig.SERVER_URL}/tenant/dr6_save`,
        {
          cert_id: selectedCertID.value,
          ts_from_utc: startDate.getTime(),
          ts_to_utc: endDate.getTime(),
          material: d.material,
          shipping_date: promptShippingDate ? promptShippingDate.getTime() : null,
          ...extraPayload,
        }, authConfig())
    ))
    // saved id = FSN; flushSync so the PDF/DORIIS file built right after has it
    const fsnByMaterial = {}
    unsaved.forEach((d, i) => { fsnByMaterial[d.material] = responses[i].data.id })
    const withFsn = DR6DataAll.map(d => d.material in fsnByMaterial ? {...d, fsn: fsnByMaterial[d.material]} : d)
    flushSync(() => {
      setDR6DataAll(withFsn)
      setDR6Data(prev => prev.material in fsnByMaterial ? {...prev, fsn: fsnByMaterial[prev.material]} : prev)
    })
    const allSaved = {}
    DR6DataAll.forEach(d => { allSaved[d.material] = true })
    setSavedMaterials(allSaved)
    setAllowSave(false)
    return withFsn
  }

  // saves any unsaved materials, then downloads the combined PDF - same as Save & Download PDF on a single page
  async function saveAllAndDownloadPdfs() {
    setAllSaving(true)
    try {
      if (allowSaveAll) {
        await saveAllMaterials()
        setAllowSaveAll(false)
        fetchDR6List(token)
      }
      if (refAllPdf.current) refAllPdf.current.save()
    } catch (err) {
      console.error('Failed to save all DR-6 reports', err)
      alert('Error saving reports.')
    }
    setAllSaving(false)
  }

  async function saveAllAndDownloadDoriis() {
    if (!promptShippingDate) {
      alert('Please select a shipping date before downloading.')
      return
    }
    if (!allDoriisReceiver) {
      alert('Please select a receiver before downloading.')
      return
    }
    setAllSaving(true)
    try {
      let entries = DR6DataAll
      if (allowSaveAll) {
        entries = await saveAllMaterials({receiver_account_number: allDoriisReceiver.value})
        setAllowSaveAll(false)
        fetchDR6List(token)
      }

      const content = generateDoriisContent(entries, allDoriisReceiver.value)
      const blob = new Blob([content], {type: 'text/plain'})
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `DORIIS_DR6_${selectedCertID.value}_${startDate.getTime()}_${endDate.getTime()}.txt`
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(url)

      setAllDoriisPromptOpen(false)
    } catch (err) {
      console.error('Failed to save all / download DORIIS', err)
      alert('Error saving reports or generating DORIIS file.')
    }
    setAllSaving(false)
  }

  async function fetchDR6Data(token) {
    console.log("Updating machine tasks")
    setIsLoading(true);

    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    if (selectedMaterials.value === 'All') {
      setDR6Data({})
      setDR6DataAll([])
      setAllowSaveAll(false)
      setAllGenerateMessage('Generating reports for all materials...')

      const allResults = await Promise.all(
        options.map(opt =>
          axios.post(
            `${ServerConfig.SERVER_URL}/tenant/dr6`,
            {
              cert_id: selectedCertID.value,
              ts_from_utc: startDate.getTime(),
              ts_to_utc: endDate.getTime(),
              material: opt.value,
              shipping_date: promptShippingDate ? promptShippingDate.getTime() : null,
            }, config)
            .then(r => ({ok: true, data: r.data}))
            .catch(err => ({ok: false, material: opt.value, err}))
        )
      )

      const failed = allResults.filter(r => !r.ok)
      const withData = allResults.filter(r => r.ok && r.data.total_weight_lbs > 0).map(r => r.data)

      setDR6DataAll(withData)
      setAllowSaveAll(withData.length > 0)
      setSavedMaterials({})
      setAllIndex(0)
      if (withData.length > 0) {
        setDR6Data(withData[0])
        setAllowSave(true)
      }

      let message = withData.length > 0
        ? ''
        : 'No material had any weight in the selected period.'
      if (failed.length > 0) {
        failed.forEach(f => console.error(`DR-6 generation failed for ${f.material}`, f.err))
        message += ` Failed to generate: ${failed.map(f => f.material).join(', ')}.`
      }
      setAllGenerateMessage(message.trim())

      setIsLoading(false);
      return
    }

    const results = await axios.post(
      `${ServerConfig.SERVER_URL}/tenant/dr6`,
      {
        cert_id: selectedCertID.value,
        ts_from_utc: startDate.getTime(),
        ts_to_utc: endDate.getTime(),
        material: selectedMaterials.value,
        actually_shipped_lbs_crv: actuallyShippedLbsCrv,
        actually_shipped_lbs_scrap: actuallyShippedLbsScrap,
        shipping_date: promptShippingDate ? promptShippingDate.getTime() : null,
      }, config).then(function (results) {
      setAllowSave(true);
      setDR6Data(results.data)
    })

    setIsLoading(false);
  }

  useEffect(() => {
    fetchCertIDList(token);
    fetchDR6List(token);
  }, [token])


  // update the start-date of the DR-6 when a material and machine are selected/changed
  useEffect(() => {
    updateStartDateForMaterial();
  }, [selectedMaterials, selectedCertID])


  // instantly update list of previous reports when a selection changes
  useEffect(() => {
    setAllowSave(false);
    setDR6Data({});
    setDR6DataAll([]);
    setAllGenerateMessage('');
    fetchDR6List(token);
  }, [selectedMaterials_prev, selectedCertID_prev, startDate_prev, endDate_prev])


  if (!token) {
    return <Redirect to="/login"/>
  }

  const first_col_xs = 5;
  const second_col_xs = 12 - first_col_xs;

  // renders react-select menus into document.body so short containers don't clip them
  const selectPortalProps = {
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    styles: {menuPortal: base => ({...base, zIndex: 9999})},
  }

  // switch tabs
  const handleChange = (event, newValue) => {
    setDR6Data({});
    setDR6DataAll([]);
    setAllGenerateMessage('');
    setAllowSave(false);
    setValue(newValue);
  };

  // PDF body, shared by the single-report preview and the "All" download
  function renderPdfBody(DR6Data) {
    return (
              <Grid container spacing={3}
                    style={{'padding': '50px', 'border': '1px solid black', 'backgroundColor': 'white'}}>
                <Grid xs={8}>
                  <h1 style={{'marginBottom': '30px'}}>DR-6 Report</h1>
                </Grid>
                <Grid xs={4} style={{'textAlign': 'right', 'paddingTop': '30px'}}>
                  <img src={logo_mono} height="40"/>
                </Grid>

                <Grid xs={12} style={{'marginBottom': '20px', 'borderTop': '1px solid gray', 'paddingTop': '10px'}}>
                  Created: {utc_timestamp_to_local_datetime_string(DR6Data.ts_create)}<br/>
                </Grid>

                <Grid xs={2}>
                  Shipper:
                </Grid>
                <Grid xs={3}>
                  Cert-ID:<br/><br/>
                  Business-Name:<br/>
                  Address:<br/><br/><br/>
                  Contact:
                </Grid>
                <Grid xs={7}>
                  {DR6Data.cert_numbers}<br/><br/>
                  {DR6Data.tenant_business_name}<br/>
                  {DR6Data.tenant_address_street}<br/>
                  {DR6Data.tenant_city_state_zip}<br/><br/>
                  {DR6Data.tenant_contact_name}
                </Grid>

                <Grid xs={12} style={{'marginBottom': '20px', 'borderTop': '1px solid gray', 'marginTop': '10px'}}>
                  {/* spacing */}
                </Grid>

                      <Grid xs={first_col_xs}>
                        Material:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.material}
                      </Grid>
                      <Grid xs={first_col_xs}>
                        Begin date/time:
                      </Grid>
                      <Grid xs={7}>
                        {utc_timestamp_to_local_datetime_string(DR6Data.begin_ts)}
                      </Grid>
                      <Grid xs={first_col_xs}>
                        End date/time:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {utc_timestamp_to_local_datetime_string(DR6Data.end_ts)}
                      </Grid>
                      <Grid xs={first_col_xs}>
                        Shipping date:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.shipping_date ? utc_timestamp_to_local_datetime_string(DR6Data.shipping_date) : ''}
                      </Grid>
                      <Grid xs={first_col_xs}>
                        FSN:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.fsn ?? '—'}
                      </Grid>

                      <Grid xs={12} style={{'marginBottom': '20px'}}>
                        {/* spacing */}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        Segregated Weight [lbs]:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('crv_weight_lbs') && DR6Data.crv_weight_lbs.toFixed(weight_decimals)}
                        {!DR6Data.hasOwnProperty('crv_weight_lbs') && (0.0).toFixed(weight_decimals)}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        Scrap Weight [lbs]:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('scrap_weight_lbs') &&
                          DR6Data.scrap_weight_lbs.toFixed(weight_decimals)
                        }
                        {!DR6Data.hasOwnProperty('scrap_weight_lbs') &&
                          (0.0).toFixed(weight_decimals)
                        }
                      </Grid>

                      <Grid xs={first_col_xs}>
                        Commingled Redemption Weight [lbs]:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('commingled_redemption_weight_lbs') &&
                          DR6Data.commingled_redemption_weight_lbs.toFixed(weight_decimals)
                        }
                        {!DR6Data.hasOwnProperty('commingled_redemption_weight_lbs') && (0.0).toFixed(weight_decimals)}
                      </Grid>

                      <Grid xs={12} style={{'marginBottom': '20px'}}>
                        {/* spacing */}
                      </Grid>

                    <Grid xs={first_col_xs}>
                      Carried over CRV weight [lbs]:
                    </Grid>
                    <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('crv_weight_rolled_over_from_previous_lbs') &&
                          <>
                            {DR6Data.crv_weight_rolled_over_from_previous_lbs.toFixed(weight_decimals)} (${DR6Data.crv_value_rolled_over_from_previous_lbs.toFixed(2)})
                          </>
                        }
                        {!DR6Data.hasOwnProperty('crv_weight_rolled_over_from_previous_lbs') && (0.0).toFixed(weight_decimals)}
                      </Grid>

                    <Grid xs={first_col_xs}>
                      Carried over Scrap weight [lbs]:
                    </Grid>
                    <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('scrap_weight_rolled_over_from_previous_lbs') &&
                          <>
                            {DR6Data.scrap_weight_rolled_over_from_previous_lbs.toFixed(weight_decimals)} (${DR6Data.scrap_value_rolled_over_from_previous_lbs.toFixed(weight_decimals)})
                          </>
                        }
                        {!DR6Data.hasOwnProperty('scrap_weight_rolled_over_from_previous_lbs') && (0.0).toFixed(weight_decimals)}
                      </Grid>


                      <Grid xs={first_col_xs}>
                        Carry-over CRV weight [lbs]:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('crv_weight_lbs_rollover') &&
                          <>
                            {DR6Data.crv_weight_lbs_rollover.toFixed(weight_decimals)} ($ {DR6Data.crv_value_rollover.toFixed(2)})
                          </>
                        }
                        {!DR6Data.hasOwnProperty('crv_weight_lbs_rollover') && (0.0).toFixed(weight_decimals)}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        Carry-over Scrap weight [lbs]:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('scrap_weight_lbs_rollover') &&
                          <>
                            {DR6Data.scrap_weight_lbs_rollover.toFixed(weight_decimals)}  ($ {DR6Data.scrap_value_rollover.toFixed(2)})
                          </>
                        }
                        {!DR6Data.hasOwnProperty('scrap_weight_lbs_rollover') && (0.0).toFixed(weight_decimals)}
                      </Grid>

                      <Grid xs={12} style={{'marginBottom': '20px'}}>
                        {/* spacing */}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        {"Count <24oz"}:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('count_S') &&
                          DR6Data.count_S.toFixed(0)
                        }
                        {!DR6Data.hasOwnProperty('count_S') && 0}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        {"Weight <24oz"}:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('crv_weight_lbs_lt24') && DR6Data.crv_weight_lbs_lt24.toFixed(weight_decimals)}
                        {!DR6Data.hasOwnProperty('crv_weight_lbs_lt24') && 0}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        {"Count >24oz"}:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('count_L') &&
                          DR6Data.count_L.toFixed(0)
                        }
                        {!DR6Data.hasOwnProperty('count_L') && 0}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        {"Weight >24oz"}:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('crv_weight_lbs_geq24') && DR6Data.crv_weight_lbs_geq24.toFixed(weight_decimals)}
                        {!DR6Data.hasOwnProperty('crv_weight_lbs_geq24') && 0}
                      </Grid>

                      <Grid xs={12} style={{'marginBottom': '20px'}}>
                        {/* spacing */}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        Total Redemption Weight:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('crv_weight_lbs') && DR6Data.crv_weight_lbs.toFixed(weight_decimals)}
                        {!DR6Data.hasOwnProperty('crv_weight_lbs') && 0}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        Total Weight:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('total_weight_lbs') && DR6Data.total_weight_lbs.toFixed(weight_decimals)}
                        {!DR6Data.hasOwnProperty('total_weight_lbs') && 0}
                      </Grid>

                      <Grid xs={first_col_xs}>
                        Total Refund Value:
                      </Grid>
                      <Grid xs={second_col_xs}>
                        {DR6Data.hasOwnProperty('crv_paid') &&
                          DR6Data.crv_paid.toFixed(2) + " (Rate: " + DR6Data.refund_rate + ")"
                        }
                        {!DR6Data.hasOwnProperty('crv_paid') && 0}
                      </Grid>

                      <Grid xs={12} style={{'marginBottom': '150px'}}>
                        {/* spacing */}
                      </Grid>

                      <Grid xs={1}></Grid>
                      <Grid container xs={3} style={{'textAlign': 'center'}}>
                        <Grid xs={12} style={{'borderTop': '1px solid black'}}></Grid>
                        <Grid xs={12}>Seller/Driver</Grid>
                      </Grid>{/* end container */}
                      <Grid xs={4}></Grid>
                      <Grid container xs={3} style={{'textAlign': 'center'}}>
                        <Grid xs={12} style={{'borderTop': '1px solid black'}}></Grid>
                        <Grid xs={12}>Buyer/Receiver</Grid>
                      </Grid>{/* end container */}
                      <Grid xs={1}></Grid>

              </Grid>
    )
  }

  return (
    <>
      <TabContext value={value}
                  style={{'marginLeft': '0', 'paddingLeft': '0', 'marginRight': '0', 'paddingRight': '0'}}>
        <TabList onChange={handleChange} aria-label="DR6-Subpages">
          <Tab label="Previous reports" value="1"/>
          <Tab label="New report" value="2"/>
        </TabList>

        <TabPanel value="1" style={{'marginLeft': '0', 'paddingLeft': '0', 'marginRight': '0', 'paddingRight': '0'}}>
          <Grid container spacing={3} style={{'borderRadius': '20px', 'backgroundColor': 'white', 'padding': '20px'}}>
            <Grid xs={12}>
              <b>Previously generated Reports:</b>
            </Grid>
            {/* selections */}
            <Grid container spacing={3} style={{'padding': '10px'}}>
              <Grid xs={12} style={{'margin-bottom': '20px', 'padding-right': '20px'}}>
                <Typography variant="h2">
                  Cert-ID:
                </Typography>

                {availableCertIDs.length > 0 &&
                  <Select
                    {...selectPortalProps}
                    name="machine_prev"
                    id="machine_prev"
                    onChange={(event) => {
                      setSelectedCertID_prev(event)
                    }}  // [{value:'', label:''}, ...]
                    options={availableCertIDs}
                    defaultValue={selectedCertID_prev}
                  />
                }
              </Grid>

              <Grid xs={5} style={{'marginBottom': '20px'}}>
                <Typography variant="h2">
                  Start-Date (incl.):
                </Typography>
                <DatePicker selected={startDate_prev} onChange={(date) => {
                  setStartDate_prev(date)
                }}
                            showTimeSelect
                            dateFormat="MMMM d, yyyy h:mm aa"
                            className="form-select"
                            popperClassName={classes.datePickerPopper}
                            />
              </Grid>

              <Grid xs={5} style={{'marginBottom': '20px'}}>
                <Typography variant="h2">
                  End-Date (incl.):
                </Typography>
                <DatePicker selected={endDate_prev} onChange={(date) => {
                  setEndDate_prev(date)
                }}
                            showTimeSelect
                            dateFormat="MMMM d, yyyy h:mm aa"
                            className="form-select"
                            popperClassName={classes.datePickerPopper}/>
              </Grid>

              <Grid xs={12} style={{'textAlign': 'left'}}>
                <Typography variant="h2">
                  Materials:
                </Typography>

                <Select
                  //isMulti
                  {...selectPortalProps}
                  name="materials_prev"
                  id="materials_prev"
                  onChange={(event) => {
                    setSelectedMaterials_prev(event)
                  }}  // [{value:'', label:''}, ...]
                  options={materialsFilterOptions}
                  defaultValue={selectedMaterials_prev}
                />
              </Grid>
            </Grid>

            <Grid xs={12} style={{'marginTop': '20px'}}>{/* spacing */}</Grid>

            <Grid xs={12}>
              <span onClick={toggleShipmentSelect} style={{'cursor': 'pointer', 'color': 'gray', 'fontSize': '0.9em'}}>
                {shipmentSelectEnabled ? '- Hide shipment selection' : '+ Combine reports into one DORIIS shipment file'}
              </span>
            </Grid>

            {shipmentSelectEnabled && Object.keys(selectedForShipment).length > 0 &&
              <Grid container spacing={2} className={classes.doriisPromptBox} style={{'marginTop': '10px'}}>
                <Grid xs={12}>
                  <b>{Object.keys(selectedForShipment).length} report(s) selected for this shipment</b>
                  {' '}({_.uniq(Object.values(selectedForShipment).map(e => materialAbbrevByValue[(e.material || e.materials)?.toLowerCase()] || e.material || e.materials)).join(', ')})
                </Grid>

                {!shipmentPromptOpen &&
                  <Grid xs={12} className={classes.doriisPromptActions}>
                    <Button onClick={clearShipmentSelection} className={classes.doriisCancelButton}>
                      Clear selection
                    </Button>
                    <Button onClick={attemptShipmentDownload}>
                      {shipmentDownloading ? '...' : 'Download Combined DORIIS File'}
                    </Button>
                  </Grid>
                }

                {shipmentPromptOpen &&
                  <>
                    <Grid xs={12}>
                      A few details are needed before this shipment can be exported. Whatever you enter applies only to reports missing it - reports that already have their own value are left as-is.
                    </Grid>

                    {Object.values(selectedForShipment).some(e => !e.shipping_date) &&
                      <Grid xs={4}>
                        <Typography variant="h2">Shipping Date:</Typography>
                        <DatePicker
                          selected={promptShippingDate}
                          onChange={(date) => setPromptShippingDate(date)}
                          showTimeSelect
                          dateFormat="MMMM d, yyyy h:mm aa"
                          className="form-select"
                        />
                      </Grid>
                    }

                    {Object.values(selectedForShipment).some(e => !e.receiver_account_number) &&
                      <Grid xs={5}>
                        <Typography variant="h2">Receiver:</Typography>
                        <Select
                          {...selectPortalProps}
                          name="shipment_receiver_picker"
                          options={receiverSearchOptions}
                          value={promptReceiverOption}
                          isLoading={receiverSearchLoading}
                          onInputChange={(value) => {
                            searchReceivers(value)
                            return value
                          }}
                          onChange={(option) => setPromptReceiverOption(option)}
                          placeholder="Search receiver by name, city, or account #"
                        />
                      </Grid>
                    }

                    <Grid xs={12} className={classes.doriisPromptActions}>
                      <Button onClick={() => setShipmentPromptOpen(false)} className={classes.doriisCancelButton}>
                        Cancel
                      </Button>
                      <Button onClick={confirmShipmentDownload}>
                        {shipmentDownloading ? '...' : 'Confirm & Download'}
                      </Button>
                    </Grid>
                  </>
                }
              </Grid>
            }

            <Grid xs={12} style={{'marginTop': '20px'}}>{/* spacing */}</Grid>
            <Grid xs={12}><b>Found {DR6List.length} reports:</b></Grid>
            {
              _.map(DR6List, (dr6line) => {
                const isAll = selectedMaterials_prev.value === 'All'
                const isChecked = selectedForShipment.hasOwnProperty(dr6line.id)
                return <>
                  <Grid container key={dr6line.id} alignItems="center">
                    {shipmentSelectEnabled &&
                      <Grid xs={1}>
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={(e) => toggleShipmentRow(dr6line, e.target.checked)}
                        />
                      </Grid>
                    }
                    <Grid xs={3}>
                      {utc_timestamp_to_local_datetime_string(dr6line.ts_created)}
                    </Grid>
                    <Grid xs={2}>
                      {isAll ? (materialAbbrevByValue[dr6line.material?.toLowerCase()] || dr6line.material) : ''}
                    </Grid>
                    <Grid xs={shipmentSelectEnabled ? 3 : 4}>
                      {utc_timestamp_to_local_datetime_string(dr6line.ts_from)} - {utc_timestamp_to_local_datetime_string(dr6line.ts_to)}
                    </Grid>
                    <Grid xs={2} onClick={() => {
                      fetchDR6byId(dr6line.id)
                    }} style={{'cursor': 'pointer'}}>
                      Load Report
                    </Grid>
                    <Grid xs={1} onClick={() => handleDoriisClick(dr6line)}
                          className={doriisDownloadingId === dr6line.id ? classes.doriisClickableDisabled : classes.doriisClickable}>
                      {doriisDownloadingId === dr6line.id ? '...' : 'DORIIS Report'}
                    </Grid>
                  </Grid> {/* end container */}

                  {/* inline prompt - only shown for this row when it's missing
                      a receiver and/or shipping date and the user clicked
                      DORIIS Report */}
                  {doriisPromptId === dr6line.id &&
                    <Grid container spacing={2}
                          className={classes.doriisPromptBox}>
                      <Grid xs={12}>
                        <b>This report needs a few details before it can be exported to DORIIS:</b>
                      </Grid>

                      {!dr6line.shipping_date &&
                        <Grid xs={4}>
                          <Typography variant="h2">Shipping Date:</Typography>
                          <DatePicker
                            selected={promptShippingDate}
                            onChange={(date) => setPromptShippingDate(date)}
                            showTimeSelect
                            dateFormat="MMMM d, yyyy h:mm aa"
                            className="form-select"
                          />
                        </Grid>
                      }

                      {!dr6line.receiver_account_number &&
                        <Grid xs={5}>
                          <Typography variant="h2">Receiver:</Typography>
                          <Select
                            {...selectPortalProps}
                            name="receiver_picker"
                            options={receiverSearchOptions}
                            value={promptReceiverOption}
                            isLoading={receiverSearchLoading}
                            onInputChange={(value) => {
                              searchReceivers(value)
                              return value
                            }}
                            onChange={(option) => setPromptReceiverOption(option)}
                            placeholder="Search receiver by name, city, or account #"
                          />
                        </Grid>
                      }

                      <Grid xs={12} className={classes.doriisPromptActions}>
                        <Button onClick={closeDoriisPrompt} className={classes.doriisCancelButton}>
                          Cancel
                        </Button>
                        <Button onClick={() => confirmDoriisDownload(dr6line)}>
                          {doriisDownloadingId === dr6line.id ? '...' : 'Confirm & Download'}
                        </Button>
                      </Grid>
                    </Grid>
                  }
                </>
              })
            }
          </Grid>
        </TabPanel>

        <TabPanel value="2" style={{'marginLeft': '0', 'paddingLeft': '0', 'marginRight': '0', 'paddingRight': '0'}}>
          <Grid container spacing={3} style={{'borderRadius': '20px', 'backgroundColor': 'white', 'padding': '20px'}}>
            <Grid xs={12} style={{'margin-bottom': '20px', 'padding-right': '20px'}}>
              <Typography variant="h2">
                Cert-ID:
              </Typography>

              {availableCertIDs.length > 0 &&
                <Select
                  //isMulti
                  /*className="form-select"*/
                  {...selectPortalProps}
                  name="machine"
                  id="machine"
                  onChange={(event) => {
                    setSelectedCertID(event)
                  }}  // [{value:'', label:''}, ...]
                  options={availableCertIDs}
                  defaultValue={availableCertIDs[0]}
                />
              }
            </Grid>

            <Grid xs={12} sm={4} style={{'marginBottom': '20px'}}>
              <Typography variant="h2">
                Start-Date (incl.):
              </Typography>
              <DatePicker selected={startDate} onChange={(date) => {
                setStartDate(date)
              }}
                          showTimeSelect
                          dateFormat="MMMM d, yyyy h:mm aa"
                          className="form-select"
                          popperClassName={classes.datePickerPopper}/>
              {startDateStatus}
            </Grid>

            <Grid xs={12} sm={4} style={{'marginBottom': '20px'}}>
              <Typography variant="h2">
                End-Date (incl.):
              </Typography>
              <DatePicker selected={endDate} onChange={(date) => {
                setEndDate(date)
              }}
                          showTimeSelect
                          dateFormat="MMMM d, yyyy h:mm aa"
                          className="form-select"
                          popperClassName={classes.datePickerPopper}/>
            </Grid>

            <Grid xs={12} sm={4} style={{'marginBottom': '20px'}}>
              <Typography variant="h2">
                Shipping Date:
              </Typography>
              <DatePicker selected={promptShippingDate} onChange={(date) => {
                setPromptShippingDate(date)
              }}
                          showTimeSelect
                          dateFormat="MMMM d, yyyy h:mm aa"
                          className="form-select"
                          popperClassName={classes.datePickerPopper}/>
            </Grid>

            <Grid xs={12} style={{'textAlign': 'left', 'marginBottom': '20px'}}>
              <Typography variant="h2">
                Materials:
              </Typography>

              <Select
                //isMulti
                {...selectPortalProps}
                name="materials"
                id="materials"
                onChange={(event) => {
                  setSelectedMaterials(event)
                  setDR6Data({})
                  setDR6DataAll([])
                  setAllGenerateMessage('')
                }}  // [{value:'', label:''}, ...]
                options={availableMaterials}
                defaultValue={selectedMaterials}
              />
            </Grid>

            <Grid xs={6} style={{'textAlign': 'left', 'paddingRight': '10px'}}>
              <Typography variant="h2">
                Different actually shipped CRV lbs:
              </Typography>

              <input type="number" className="form-control" name="lbs_actual" id="lbs_actual" value={actuallyShippedLbsCrv} defaultValue={-1} onChange={(event) => {setActuallyShippedLbsCrv(event.target.value)}} />
            </Grid>

            <Grid xs={6} style={{'textAlign': 'left', 'paddingLeft': '10px'}}>
              <Typography variant="h2">
                Different actually shipped Scrap lbs:
              </Typography>

              <input type="number" className="form-control" name="lbs_actual" id="lbs_actual" value={actuallyShippedLbsScrap} defaultValue={-1} onChange={(event) => {setActuallyShippedLbsScrap(event.target.value)}} />
            </Grid>

            {/* compact note in the free bottom-left space, same icon/colour as InfoBanner */}
            <Grid xs={8} style={{'paddingTop': '20px', 'fontSize': '0.85em', 'display': 'flex', 'alignItems': 'center'}}>
              <InfoOutlined fontSize="small" style={{'color': 'rgb(0,79,113)', 'marginRight': '6px'}}/>
              <span><b>Important:</b> the FSN (DORIIS tracking number) is assigned when the report is saved.</span>
            </Grid>

            <Grid xs={4} style={{'paddingTop': '20px', 'textAlign': 'right'}}>
              <Button onClick={() => {
                fetchDR6Data(token)
              }}>Generate DR-6</Button>
            </Grid>
          </Grid>

        </TabPanel>

      </TabContext>

      {allGenerateMessage &&
        <Grid xs={12} style={{'marginTop': '20px'}}>{allGenerateMessage}</Grid>
      }

      {DR6DataAll.length > 0 &&
        <Grid container style={{'marginTop': '30px', 'borderRadius': '20px', 'backgroundColor': 'white', 'padding': '20px'}}>
          <Grid xs={12} style={{'marginBottom': '10px'}}>
            <b>Generated {DR6DataAll.length} material report(s). Page through them below or click View.</b>
          </Grid>

          <Grid container style={{'fontWeight': 'bold', 'borderBottom': '1px solid black', 'paddingBottom': '6px'}}>
            <Grid xs={2}>Material</Grid>
            <Grid xs={2}>Segregated [lbs]</Grid>
            <Grid xs={2}>Scrap [lbs]</Grid>
            <Grid xs={2}>Total [lbs]</Grid>
            <Grid xs={2}>Refund Value</Grid>
            <Grid xs={2}></Grid>
          </Grid>

          {_.map(DR6DataAll, (d) =>
            <Grid container key={d.material} style={{'borderBottom': '1px solid #e0e0e0', 'padding': '4px 0'}}>
              <Grid xs={2}>{d.material}</Grid>
              <Grid xs={2}>{(d.crv_weight_lbs || 0).toFixed(weight_decimals)}</Grid>
              <Grid xs={2}>{(d.scrap_weight_lbs || 0).toFixed(weight_decimals)}</Grid>
              <Grid xs={2}>{(d.total_weight_lbs || 0).toFixed(weight_decimals)}</Grid>
              <Grid xs={2}>${(d.crv_paid || 0).toFixed(2)}</Grid>
              <Grid xs={2} onClick={() => goToAllPage(DR6DataAll.indexOf(d))} style={{'cursor': 'pointer'}}>
                {DR6DataAll.indexOf(d) === allIndex ? 'Viewing' : 'View'}{savedMaterials[d.material] ? ' (saved)' : ''}
              </Grid>
            </Grid>
          )}

          <Grid xs={12} style={{'marginTop': '16px', 'textAlign': 'right'}}>
            <Button onClick={saveAllAndDownloadPdfs} disabled={allSaving}>
              {allSaving ? '...' : (allowSaveAll ? 'Save & Download All PDFs' : 'Download All PDFs')}
            </Button>
            {!allDoriisPromptOpen &&
              <Button onClick={() => {
                setAllDoriisReceiver(null)
                if (!promptShippingDate) setPromptShippingDate(new Date())
                setReceiverSearchOptions([])
                searchReceivers('')
                setAllDoriisPromptOpen(true)
              }}>
                {allowSaveAll ? 'Save All & Download DORIIS' : 'Download DORIIS'}
              </Button>
            }
          </Grid>

          {allDoriisPromptOpen &&
            <Grid container spacing={2} style={{'marginTop': '10px'}}>
              <Grid xs={4}>
                <Typography variant="h2">Shipping Date:</Typography>
                <DatePicker
                  selected={promptShippingDate}
                  onChange={(date) => setPromptShippingDate(date)}
                  showTimeSelect
                  dateFormat="MMMM d, yyyy h:mm aa"
                  className="form-select"
                  popperClassName={classes.datePickerPopper}
                />
              </Grid>
              <Grid xs={6}>
                <Typography variant="h2">Receiver:</Typography>
                <Select
                  {...selectPortalProps}
                  name="all_doriis_receiver"
                  options={receiverSearchOptions}
                  value={allDoriisReceiver}
                  isLoading={receiverSearchLoading}
                  onInputChange={(value) => {
                    searchReceivers(value)
                    return value
                  }}
                  onChange={(option) => setAllDoriisReceiver(option)}
                  placeholder="Search receiver by name, city, or account #"
                />
              </Grid>
              <Grid xs={12} style={{'textAlign': 'right'}}>
                <Button onClick={() => setAllDoriisPromptOpen(false)}>Cancel</Button>
                <Button onClick={saveAllAndDownloadDoriis} disabled={allSaving}>
                  {allSaving ? '...' : 'Confirm & Download'}
                </Button>
              </Grid>
            </Grid>
          }
        </Grid>
      }

      <Grid xs={12} style={{'marginTop': '30px'}}>
        {DR6Data.hasOwnProperty('ts_create') &&
          <>
            {DR6DataAll.length > 0 &&
              <div style={{'marginBottom': '10px'}}>
                <Button onClick={() => goToAllPage(allIndex - 1)} disabled={allIndex === 0}>Previous</Button>
                <span style={{'margin': '0 12px'}}>
                  {DR6Data.material} ({allIndex + 1} of {DR6DataAll.length}){savedMaterials[DR6Data.material] ? ' - saved' : ''}
                </span>
                <Button onClick={() => goToAllPage(allIndex + 1)} disabled={allIndex === DR6DataAll.length - 1}>Next</Button>
              </div>
            }
            {allowSave &&
              <>
                <Button onClick={() => {
                  // ignore repeat clicks while the save is still in flight
                  if (ref.current && !savingRef.current) {
                    // wait for the save so the PDF carries the FSN
                    mark_saved()
                      .then(() => ref.current && ref.current.save())
                      .catch(err => {
                        console.error('Failed to save DR-6 report', err)
                        alert('Error saving report.')
                      })
                  }
                }}>Save & Download PDF</Button>
              </>
            }
            {!allowSave &&
              <>
                <Button onClick={() => {
                  if (ref.current) {
                    ref.current.save();
                  }
                }}>Download PDF</Button>
              </>
            }
            <PDFExport
              scale={0.5}
              pageTemplate={PageTemplate}
              forcePageBreak=".page-break"
              multiPage="true"
              paperSize="letter"
              fileName={"DR6_" + DR6Data.ts_create + "_" + (DR6Data.material || selectedMaterials.label) + ".pdf"}
              //margin="0.5cm"
              margin={{top: '1.5cm', bottom: '2.5cm', right: '0.5cm', left: '0.5cm'}}
              ref={ref}>

              {renderPdfBody(DR6Data)}
            </PDFExport>
          </>
        }
      </Grid>{/* end grid container for dr6 output */}

      {/* off-screen, only used by "Download All PDFs" */}
      {DR6DataAll.length > 0 &&
        <div style={{'position': 'absolute', 'left': '-10000px', 'top': '0'}}>
          <PDFExport
            scale={0.5}
            pageTemplate={PageTemplate}
            forcePageBreak=".page-break"
            multiPage="true"
            paperSize="letter"
            fileName={"DR6_All_" + selectedCertID.value + "_" + startDate.getTime() + "_" + endDate.getTime() + ".pdf"}
            margin={{top: '1.5cm', bottom: '2.5cm', right: '0.5cm', left: '0.5cm'}}
            ref={refAllPdf}>
            {_.map(DR6DataAll, (d, idx) =>
              <div key={d.material} className={idx > 0 ? 'page-break' : ''}>
                {renderPdfBody(d)}
              </div>
            )}
          </PDFExport>
        </div>
      }
    </>
  )
}

export default DR6